<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap class="mt-3">
      <v-flex xs12>
        <Stepper step="2"></Stepper>
      </v-flex>

      <ShipmentInfo :shipment="shipment" @fetch="fetch"></ShipmentInfo>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select :items="packages"
                          item-value="id"
                          item-text="name"
                          :label="$t('templates')"
                          v-on:change="setParcel"
                          return-object
                          ></v-select>
              </v-flex>

              <v-flex xs4>
                <v-select v-model="parcel.parcel_type"
                          :items="parcelTypes"
                          item-value="id"
                          item-text="name"
                          :label="$t('attrs.parcel_type')"
                          ></v-select>
              </v-flex>

              <v-flex xs4>
                <v-text-field v-model="parcel.declared_tax_value"
                  name="declaredValue"
                  :label="$t('declaredTaxValue')"
                  v-validate="'required|decimal'"
                  :error-messages="errors.collect('declaredValue')"
                  data-vv-name="declaredValue"
                  :data-vv-as="$t('declaredTaxValue')"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs4>
                <v-autocomplete
                  v-model="parcel.sat_product_id"
                  :items="satProducts"
                  :search-input.sync="satProductSearch"
                  hide-no-data
                  hide-selected
                  item-text="description"
                  item-value="code"
                  :label="$t('attrs.sat_product_id')"
                  :placeholder="$t('attrs.sat_product_id')"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 v-if="parcel.parcel_type !== 'doc'">
                <v-layout row wrap>
                  <v-flex xs12 md3>
                    <v-text-field v-model="parcel.length"
                                  name="length"
                                  :label="$t('attrs.length')"
                                  v-validate="'required|decimal|min_value:1'"
                                  :error-messages="errors.collect('length')"
                                  data-vv-name="length"
                                  :data-vv-as="$t('attrs.length')"
                                  :readonly="!parcel.editable"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field v-model="parcel.width"
                                  name="width"
                                  :label="$t('attrs.width')"
                                  v-validate="'required|decimal|min_value:1'"
                                  :error-messages="errors.collect('width')"
                                  data-vv-name="width"
                                  :data-vv-as="$t('attrs.width')"
                                  :readonly="!parcel.editable"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field v-model="parcel.height"
                                  name="height"
                                  :label="$t('attrs.height')"
                                  v-validate="'required|decimal|min_value:1'"
                                  :error-messages="errors.collect('height')"
                                  data-vv-name="height"
                                  :data-vv-as="$t('attrs.height')"
                                  :readonly="!parcel.editable"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-select v-model="parcel.distance_unit"
                              :items="distanceUnits"
                              item-value="id"
                              item-text="name"
                              :label="$t('attrs.distance_unit')"
                              :readonly="!parcel.editable"
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 md3>
                    <v-text-field v-model="parcel.weight"
                                  name="weight"
                                  :label="$t('attrs.weight')"
                                  v-validate="'required|decimal|min_value:0.1'"
                                  :error-messages="errors.collect('weight')"
                                  data-vv-name="weight"
                                  :data-vv-as="$t('attrs.weight')"
                                  :readonly="!parcel.editable"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-select v-model="parcel.mass_unit"
                              :items="massUnits"
                              item-value="id"
                              item-text="name"
                              :label="$t('attrs.mass_unit')"
                              :readonly="!parcel.editable"
                              ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <v-text-field v-model="parcel.contents"
                  name="contents"
                  :label="$t('attrs.contents')"
                  v-validate="'required'"
                  :error-messages="errors.collect('contents')"
                  data-vv-name="contents"
                  :data-vv-as="$t('attrs.contents')"
                  :readonly="!parcel.editable"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs6 class="pt-0 pb-0" v-if="parcel.parcel_type === 'box'">
                <v-checkbox v-model="myPackage.saveToPackages" :label="$t('savePackage')" @change="savePackage"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 class="text-xs-right">
        <v-btn color="primary" flat @click="goTo('shipments')" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" @click="submit" :loading="loading">
          {{ $t('saveContinue') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

import Shipment from '@/client/shipment'
import Parcel from '@/client/parcel'
import UserPackage from '@/client/user-package'
import MyPackage from '@/client/package'

import Stepper from '@/components/shipments/stepper'
import ShipmentInfo from '@/components/shipments/info'

export default {
  name: 'ParcelFormView',

  props: {},

  data () {
    return {
      loading: false,
      shipment: {},
      parcel: {},
      myPackage: {},
      parcelTypes:[
        { id: 'box', name: this.$t('list.parcelTypes.box') },
        { id: 'doc', name: this.$t('list.parcelTypes.doc') },
        { id: 'ltl', name: this.$t('list.parcelTypes.ltl') }
      ],
      distanceUnits: [
        { id: 'cm', name: 'CM' }
      ],
      massUnits: [
        { id: 'kg', name: 'KG' }
      ],
      satProducts: [],
      satProductSearch: '',
      packages: [],
    }
  },

  components: {
    Stepper,
    ShipmentInfo
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.shipment = await Shipment.findOne(this.$route.params.shipmentId, {
        include: ['origin', 'destination']
      })
    },

    getSatList(){
      var result = Parcel.GetSatList();

      return result.data
    },

    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        this.parcel.contents = this.parcel.contents.spanishize()
        this.parcel.shipment_id = this.shipment.id
        await this.parcel.save()
        this.goTo('newRate', { shipmentId: this.shipment.id })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    setParcel(selectedPackage) {
      this.parcel.parcel_type = selectedPackage.package_type || 'box'
      this.parcel.distance_unit = selectedPackage.distance_unit
      this.parcel.mass_unit = selectedPackage.mass_unit
      this.parcel.weight = selectedPackage.weight
      this.parcel.length = selectedPackage.length
      this.parcel.height = selectedPackage.height
      this.parcel.width = selectedPackage.width
      this.parcel.contents = selectedPackage.contents
      this.parcel.sat_product_id = selectedPackage.sat_product_id
      this.parcel.declared_tax_value = selectedPackage.declared_tax_value || 0
      this.parcel.insure_package = selectedPackage.insure_package || false
    },

    async savePackage () {
      if (this.myPackage.saveToPackages === true) {
        const isValid = await this.$validator.validateAll()

        if (!isValid) {
          this.myPackage.saveToPackages = false;
          return
        }

        try {
          this.myPackage.parcel_type = this.parcel.parcel_type;
          this.myPackage.length = this.parcel.length;
          this.myPackage.width = this.parcel.width;
          this.myPackage.height = this.parcel.height;
          this.myPackage.weight = this.parcel.weight;
          this.myPackage.name = 'package_'+this.parcel.weight;
          this.myPackage.contents = this.parcel.contents;
          this.myPackage.sat_product_id = this.parcel.sat_product_id;
          this.myPackage.user_id = this.$auth.currentUser.id
          this.myPackage.visible = true

          this.packageToSave = new MyPackage({...this.myPackage})

          await this.packageToSave.save()
        } catch (err) {
          this.handleErr(err)
        }
      }
    },

    async searchSatProduct (val) {
      const url = 'https://sat.api.hydraship.app/api/products'
      const res = await axios.get(url, { params: { search: val } })
      this.satProducts = res.data.data
    }
  },

  watch: {
    satProductSearch(val) {
      this.searchSatProduct(val)
    }
  },

  async mounted () {
    const newShipment = JSON.parse(window.sessionStorage.getItem('new_shipment') || '{}')

    await this.fetch()

    if (this.shipment.step === 'rating') {
      this.goTo('newRate', { shipmentId: this.shipment.id })
    }

    UserPackage.shipmentId = this.shipment.id
    this.packages = await UserPackage.all()

    Parcel.shipmentId = this.shipment.id
    this.parcel = new Parcel({
      parcel_type: 'box',
      distance_unit: 'cm',
      mass_unit: 'kg',
      weight: newShipment.weight,
      length: newShipment.length,
      height: newShipment.height,
      width: newShipment.width,
      sat_product_id: '',
      declared_tax_value: 0,
      editable: true
    })

    this.myPackage = new UserPackage({
      distance_unit: 'cm',
      mass_unit: 'kg',
      weight: newShipment.weight,
      length: newShipment.length,
      height: newShipment.height,
      width: newShipment.width,
      sat_product_id: '',
      declared_tax_value: 0,
      editable: false
    })
  }
}
</script>
